import { IInstitutionsProgramTypes } from '@ucheba/store/institutions/program-types/types'
import { getSingleQuery, redirect } from '@ucheba/utils/helpers/router'
import { NextPageContext } from 'next'
import { institutionsProgramsThunks } from '@ucheba/store/institutions/programs'
import { institutionProgramsLimit } from '@ucheba/store/institutions/programs/constants'
import { Dispatch } from 'react'
import { types } from '../index/constants'

const returnPromise = new Promise((resolve) => {
  setTimeout(() => {
    resolve(true)
  }, 10)
})

export const getProgramType = (
  slug: string | undefined | null,
  programTypes: IInstitutionsProgramTypes[]
): IInstitutionsProgramTypes | undefined => {
  return programTypes.find((type) => {
    return type.slug === slug
  })
}

export const programTypesRedirect = async (
  slug: string | undefined | null,
  programTypes: IInstitutionsProgramTypes[],
  ctx: NextPageContext
): Promise<any> => {
  const { query } = ctx
  const id = getSingleQuery(query.id)

  const programType = getProgramType(slug, programTypes)

  if (!programType || programTypes[0].slug === programType.slug) {
    delete ctx.query.id
    delete ctx.query.slug

    redirect({
      location: `/uz/${id}/programs`,
      ctx,
      withQuery: true,
    })
  }

  return returnPromise
}

interface IParamsCurrentPrograms {
  id: string
  slug: string
}

export const fetchCurrentPrograms = async (
  id: string | null | undefined,
  offset: number,
  params: IParamsCurrentPrograms,
  programType: number,
  dispatch: Dispatch<any>,
  hasPrograms?: boolean
): Promise<any> => {
  if (hasPrograms && types.height.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchProgramsHigher({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }

  if (types.master.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchProgramsMaster({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }

  if (types.postgraduate.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchProgramsPostgraduate({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }

  if (types.vocational.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchProgramsVocational({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }

  if (types.course.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchProgramsCourse({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }

  if (types.mba.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchProgramsMBA({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }

  if (types.school.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchProgramsSchool({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }

  if (types.preparatory.includes(programType)) {
    await dispatch(
      institutionsProgramsThunks.fetchPreparatory({
        data: {
          institutionIds: id,
          limit: institutionProgramsLimit,
          offset,
          ...params,
        },
      })
    )
  }
}
